module.exports = __webpack_public_path__ + "static/media/Inventor Multi Monitor Document Support.593cdaaf.png";